import React from 'react'
import Link from 'next/link'
import { LinkToPropertyBase } from './styles'

interface ILinkToProperty {
  readonly propertyId: string
  readonly children: React.ReactNode
}

export function LinkToProperty({ propertyId, children }: ILinkToProperty) {
  return (
    <Link href={`/hotel-detail/${propertyId}`} passHref>
      <LinkToPropertyBase target="_blank" rel="noopener">
        {children}
      </LinkToPropertyBase>
    </Link>
  )
}
